// extracted by mini-css-extract-plugin
export default {"selected":"profileDashboard_selected__wRkqJ","link":"profileDashboard_link__QxSdK","logout":"profileDashboard_logout__3zhFe"};